<section
  class="section-content-media"
  [class.section-content-media--right]="data().mediaPosition === 'right'"
  [class.section-content-media--left]="data().mediaPosition === 'left'"
  [style.--padding-top.px]="design().padding.top"
  [style.--padding-bottom.px]="design().padding.bottom"
>
  <div
    class="section-content-media__content"
    [class.section-content-media--vertical-centered]="data().contentAlignment === 'center'"
  >
    @for (item of content(); track item.id) {
      <ng-template [paiInsertDynamicContent]="item" />
    }
  </div>
  <div class="section-content-media__media">
    <ng-template [paiInsertDynamicContent]="mediaItem()" />
  </div>
</section>
